import { AppBreadcrumb } from "./-components/app-breadcrumb"
import { AppSidebar } from "./-components/app-sidebar"
import { UserButton, useUser } from "@clerk/clerk-react"
import { createFileRoute, Outlet, Navigate, Link } from "@tanstack/react-router"
import { useQuery } from "convex/react"
import { api } from "@convex/_generated/api"
import { Button } from "@/components/ui/button"

import {
  SidebarInset,
  SidebarProvider,
  SidebarTrigger,
} from "@/components/ui/sidebar"

export const Route = createFileRoute("/(app)/app")({
  component: RouteComponent,
})

function RouteComponent() {
  const { isSignedIn, isLoaded } = useUser()
  const currentUser = useQuery(api.users.handlers.current)
  const isAdmin = useQuery(api.users.handlers.isAdmin, {})

  // Show loading state while Clerk is initializing
  // This prevents any flash of protected content
  if (!isLoaded) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="text-center">
          <p className="text-muted-foreground">Loading...</p>
        </div>
      </div>
    )
  }

  // Declaratively redirect if not authenticated
  // This is more React-ish than using useEffect
  if (!isSignedIn) {
    return <Navigate to="/auth" replace />
  }

  // Show loading state while fetching user data
  if (currentUser === undefined) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="text-center">
          <p className="text-muted-foreground">Loading...</p>
        </div>
      </div>
    )
  }

  // Allow dashboard access for all authenticated users
  // Access control is now handled per-quiz based on subscriptions and tickets
  return (
    <SidebarProvider>
      <AppSidebar />
      <SidebarInset>
        <header className="bg-background sticky top-0 z-10 flex w-full items-center justify-between gap-2 border-b px-4 py-3">
          <div className="flex items-center gap-2">
            <SidebarTrigger />
            <AppBreadcrumb />
          </div>
          <div className="flex items-center gap-2">
            {isAdmin && (
              <Link to="/admin">
                <Button variant="outline" size="sm">
                  Admin
                </Button>
              </Link>
            )}
            <UserButton />
          </div>
        </header>
        <div className="mx-4">
          <Outlet />
        </div>
      </SidebarInset>
    </SidebarProvider>
  )
}
